import { IconOtherClose } from '@doltech/icons/IconOtherClose';
import { Box } from '@doltech/ui/lib/figma/Common/BoxV2';
import { MotionDrawer } from '@doltech/ui/lib/figma/MotionDrawer/MotionDrawer';
import * as React from 'react';
import styled from 'styled-components';

const CLOSE_BUTTON_SIZE = 24;

const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${CLOSE_BUTTON_SIZE}px;
  height: ${CLOSE_BUTTON_SIZE}px;
  min-width: ${CLOSE_BUTTON_SIZE}px;
  border-radius: 50%;
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
`;

export const StudentDoGrammarInfoDrawer = (props) => {
  const { tocTitle, items, editorItems, scrollContainerElm, onClose, children, ...rest } = props;

  return (
    <MotionDrawer placement="bottom" onClose={onClose} transparent {...rest}>
      <Box
        display="flex"
        flexDirection="column"
        bg="white100"
        maxHeight="80vh"
        borderRadius="24px 24px 0 0"
        padding="14px 16px"
      >
        <CloseButton onClick={onClose}>
          <IconOtherClose fontSize={20} />
        </CloseButton>
        {children}
      </Box>
    </MotionDrawer>
  );
};
